import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authUrlSelector } from '../store/selectors/authentication-selectors';
import { isSafeHttpsUrl } from '../helpers/smg-auth-helper';

interface AuthStartPageProps {
  loginUrl: string;
}

interface AuthStartState {}

export class AuthStartPage extends Component<AuthStartPageProps, AuthStartState> {
  render() {
    if (isSafeHttpsUrl(this.props.loginUrl)) {
      window.location.assign(this.props.loginUrl);
    } else if (this.props.loginUrl) {
      console.error('Refusing to redirect to a login URL that is not https');
    }
    return <div></div>;
  }
}

// eslint-disable-next-line
const mapStateToProps = (state: any) => ({
  loginUrl: authUrlSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthStartPage);
